import * as React from 'react';

import { trackUnscopedButtonClicked } from '@/app-shell/ui/tracked-button-click';
import { type ButtonAction } from '@heidi/analytics/vocabulary';
import { Button, type ButtonProps } from '@heidi/design-system/button';

export interface TrackedButtonProps extends ButtonProps {
  actionTrackingName?: ButtonAction;
}

export const TrackedButton = React.forwardRef<HTMLButtonElement, TrackedButtonProps>(
  ({ onClick, actionTrackingName, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        onClick={(e) => {
          onClick?.(e);
          if (actionTrackingName) {
            trackUnscopedButtonClicked(
              actionTrackingName,
              e.currentTarget.textContent ?? ''
            );
          }
        }}
        {...props}
      />
    );
  }
);
TrackedButton.displayName = 'TrackedButton';
